import type { BrowserCacheResourceConfig } from '../controllers/browserCacheController/types';
import { getStaticResourceUrl } from '../utils/getStaticBaseUrl';

export const CoreResources: BrowserCacheResourceConfig = {
  /* fonts */
  REGULAR: {
    url: getStaticResourceUrl('assets/fonts/Poppins-Regular.woff2'),
    priority: 'block',
    kind: 'font',
  } /* core default regular */,
  BOLD: {
    url: getStaticResourceUrl('assets/fonts/Poppins-SemiBold.woff2'),
    priority: 'block',
    kind: 'font',
  } /* core default bold */,
  CARD: {
    url: getStaticResourceUrl('assets/fonts/PragmaticFlatCards.woff2'),
    priority: 'block',
    kind: 'font',
  } /* core cards */,
  CHIP: {
    url: getStaticResourceUrl('assets/fonts/Montserrat-Chip.woff2'),
    priority: 'block',
    kind: 'font',
  } /* core chips */,
};
